import { TranslationRequestDto, TranslationResponseListDto } from '@hello-hola/shared-schema';
import { KyInstance } from 'ky';

export class TranslationService {
    constructor(private readonly apiClient: KyInstance) {}

    translate = async (params: TranslationRequestDto): Promise<TranslationResponseListDto> => {
        return this.apiClient.post('translate', { json: params }).json();
    };
}
